import applicationScenariosTypes from './types/applicationScenarios'
import applicationScenariosService from '@/api/applicationScenarios'

const state = {}

const actions = {
  /**
   * 获取1h雨量超300mm
   */
  [applicationScenariosTypes.GET_OVERFLOW30MM_RAINBEFORE1HOUR] ({ commit }, {
    sID = ''
  }) {
    return new Promise((resolve, reject) => {
      applicationScenariosService.getOverflow30mmRainBefore1Hour({
        sID
      }).then(res => {
        resolve(res.data)
      }).catch(err => reject(err))
    })
  },
  /**
   * 获取3h雨量超50mm
   */
  [applicationScenariosTypes.GET_OVERFLOW50MM_RAINBEFORE3HOUR] ({ commit }, {
    sID = '22'
  }) {
    return new Promise((resolve, reject) => {
      applicationScenariosService.getOverflow50mmRainBefore3Hour({
        sID
      }).then(res => {
        resolve(res.data)
      }).catch(err => reject(err))
    })
  },
  /**
   * 获取水库水位
   */
  [applicationScenariosTypes.GET_LATEST_WATER_LEVEL] ({ commit }, {
    sID = '22',
    sTID = '',
    beginDate = '',
    endDate = '',
    stationType = ''
  }) {
    return new Promise((resolve, reject) => {
      applicationScenariosService.getHourlyRiverLevel({
        sID,
        sTID,
        beginDate,
        endDate,
        stationType
      }).then(res => {
        resolve(res.data)
      }).catch(err => reject(err))
    })
  }
}

const mutations = {}

export default {
  state,
  actions,
  mutations
}
